import { HitsPerPage } from 'react-instantsearch-dom'
import styled from 'styled-components'

export default styled(HitsPerPage).attrs({
  defaultRefinement: 25,
  items: [],
})`
  display: none;
`
